import { gql } from "@apollo/client";

export const DELETE_EXPERIENCE = gql`
  mutation deleteExperience($experienceId: ExperienceID!) {
    deleteExperience(experienceId: $experienceId) {
      id
    }
  }
`;
